import { render, staticRenderFns } from "./ModalSolicitacaoCancelamentoTriagem.vue?vue&type=template&id=c8916446&scoped=true"
import script from "./ModalSolicitacaoCancelamentoTriagem.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCancelamentoTriagem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8916446",
  null
  
)

export default component.exports